var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('el-alert',{attrs:{"title":"正在跳转...","type":"info","show-icon":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }